<template>
  <div class="page-navbar-group">
    <label ref="dropdownTrigger" class="page-navbar-group align-middle m-0 page-search-bar" data-toggle="dropdown">
      <i class="far fa-search page-navbar-search-icon align-middle"></i>
      <input type="text" class="form-control page-header-search-bar" v-model="searchText" v-on:keyup.enter="searchEnter" placeholder="Search" />
      <button class="btn bg-transparent search-cancel-button" v-if="searchText" @click.prevent="clearSearch">
        <i class="fa fa-times"></i>
      </button>
    </label>
    <ul ref="dropdownMenu" class="dropdown-menu search-dropdown-menu" v-show="searchVisible">
      <span class="search-results-loading" v-show="loading">
        <p class="text-muted font-italic text-center mt-2">Searching...</p>
        <Spinner v-show="loading" />
        <span class="mb-2">&nbsp;</span>
      </span>
      <span v-if="!loading && searchResults.length == 0">
        <p class="text-muted font-italic text-center mt-2">No results found</p>
      </span>
      <template v-for="(searchGroup, index) in searchResults">
        <h6 :key="`header-${index}`" class="search-group-header" v-if="!loading">{{searchGroup.name}}</h6>
        <DropdownMenuItem v-for="(item, itemIndex) in searchGroup.results" :key="`item-${index}-${itemIndex}`" v-show="!loading" :link="item.link" @click="viewSearchResult(item.link)" :icon="item.icon">{{item.name}}</DropdownMenuItem>
      </template>
    </ul>
  </div>
</template>

<style>
.search-cancel-button {
  margin-left: -40px;
  z-index: 100;
  color: #b0b0b0;
}
.search-group-header {
  font-weight: bold;
  font-size: 17px;
  color: #909090;
  margin: 14px 14px 8px 8px;
}
.search-dropdown-menu {
  width: 40%;
  min-height: 60px;
  font-size: 14px;
}
.search-dropdown-menu > li > a:focus,
.search-dropdown-menu > li > a:hover {
  background-color: #4282DD;
  color: #ffffff;
}
.page-navbar-search-icon {
  font-size: 130%;
  color: #b7b7b7;
}
input.page-header-search-bar {
  margin-top: 2px;
  margin-bottom: 2px;
  border: none;
  background: transparent;
  color: #efefef;
  transition: width .15s ease-in;
}
input.page-header-search-bar:focus {
  background: transparent;
  color: #efefef;
}
input.page-header-search-bar::-webkit-input-placeholder,
input.page-header-search-bar::-moz-placeholder,
input.page-header-search-bar::-ms-input-placeholder,
input.page-header-search-bar::placeholder {
  color: #b7b7b7;
  opacity: 1;
}

.page-search-bar {
  background: #303030;
  border-radius: 8px;
  padding-left: 4px;
}



@media (min-width: 768px) {
  input.page-header-search-bar {
    width: 80px;
  }
  input.page-header-search-bar:focus {
    width: 300px;
  }
}
.search-results-loading {
  width: 100%;
}

@media (max-width: 1450px) {
  .page-navbar-group {
    display: block;
    z-index: 2001;
    width: 0;
    overflow: hidden;
  }
}

</style>

<script>
import _ from 'lodash'
import Utils from '@/utils/utils'

export default {
  name: 'NavbarSystemSearch',
  data() {
    return {
      searchText: '',
      searchResults: [],
      loading: false
    }
  },
  computed: {
    searchVisible() {
      return this.$data.searchText.length > 0
    }
  },
  watch: {
    searchText: function(newVal, oldVal) {
      this.loading = true
      this.debouncedSearch()

      if(this.$data.searchText.length > 0) {
        if(!$(this.$refs.dropdownMenu).hasClass('show')) {
          $(this.$refs.dropdownTrigger).dropdown('toggle')
          $(this.$refs.dropdownTrigger).dropdown('update')
        }
      }
    }
  },
  created: function() {
    this.debouncedSearch = _.debounce(this.requestSearchInfo, 250)
  },
  methods: {
    requestSearchInfo() {
      if(this.$data.searchText == '') {
        this.loading = false
        this.searchResults = []
        return
      }
      
      this.$api.get(`/search?search=${encodeURIComponent(this.$data.searchText)}`)
      .then(response => {
        this.searchResults = response.data
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        this.loading = false
      })
    },
    viewSearchResult(link) {
      // Access the link
      // Note: Pages will need to correctly support beforeRouteUpdate() events to change pages for same components
      this.$router.push(link)     
      this.clearSearch() 
    },
    clearSearch() {
      this.$data.searchText = ''
    },
    searchEnter() {
      // Visit the 1st link in the search results
      if(this.searchResults.length > 0) {
        var group = this.searchResults[0]
        if(group.results.length > 0)
          this.viewSearchResult(group.results[0].link)
      }
    }
  }
}
</script>
